import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import LoginPage from './pages/LoginPage';
import reportWebVitals from './reportWebVitals';
import Dashboard from './pages/Dasboard';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';  // ← INI YANG DIGANTI
import RegisterPage from './pages/RegisterPage';
import UnprotectedRoute from './Midleware/UnprotectedRoute';
import ProtectedRoute from './Midleware/ProtectedRoute';
import NotificationPage from './pages/NotificationPage';
import RemindersReport from './pages/Reminders/report';
import User from './pages/UserPage';
import RolePermission from './pages/RolePermission';
// Datatable
import 'primereact/resources/themes/saga-blue/theme.css'; 
import 'primereact/resources/primereact.min.css';
import { Provider } from 'react-redux';
import store from './redux/store';
import { PrimeReactProvider } from 'primereact/api';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <Provider store={store}>
        <Router>  {/* ← SEKARANG SUDAH HASHROUTER */}
          <Routes>
            <Route path="/" element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>} />

            <Route path="/login" element={<UnprotectedRoute> <LoginPage /> </UnprotectedRoute>} />
            <Route path="/register" element={<UnprotectedRoute> <RegisterPage /> </UnprotectedRoute>} />

            <Route path="/notification" element={<ProtectedRoute> <NotificationPage /> </ProtectedRoute>} />
            <Route path="/claim-invoice" element={<ProtectedRoute> <RemindersReport /> </ProtectedRoute>} />

            <Route path="/role-permission" element={<ProtectedRoute> <RolePermission /> </ProtectedRoute>} />
            <Route path="/user" element={<ProtectedRoute> <User /> </ProtectedRoute>} />

          </Routes>
        </Router>
      </Provider>
    </PrimeReactProvider>
  </React.StrictMode>
);

reportWebVitals();